<template>
  <div class="right_col" role="main">
    <div class="row">
      <div class="col-md-12 col-sm-6 col-xs-12">
        <div class="title_left">
          <h3>司機繳費總表(試用版)</h3>
          <hr />
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="x_panel">
        <div class="x_content">
          <ul class="nav nav-tabs fontSize20" id="myTab" role="tablist">
            <li class="nav-item active">
              <a
                class="nav-link"
                id="bill-tab"
                data-toggle="tab"
                href="#nav-bill"
                role="tab"
                aria-controls="bill"
                aria-expanded="true"
              >
                當月司機繳費狀況
                <span style="color: #ff7c7c"></span>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="driver-tab"
                data-toggle="tab"
                href="#driver"
                role="tab"
                aria-controls="message"
                aria-selected="false"
              >
                司機歷史繳費狀況
                <span style="color: #ff7c7c"></span>
              </a>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div
              class="tab-pane fade active in"
              id="nav-bill"
              role="tabpanel"
              aria-labelledby="bill-tab"
            >
              <div class="row">
                <select
                  v-model="year"
                  @change="getMonthOptions()"
                  class="inputstyle col-md-1 blockmargin"
                >
                  <option v-for="year in years" :value="year">
                    {{ year }}
                  </option>
                </select>
                <select
                  @change="getList"
                  v-model="month"
                  class="inputstyle col-md-1 blockmargin"
                >
                  <option v-for="month in months" :value="month">
                    {{ month }}
                  </option>
                </select>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <label>
                    <select
                      v-model="npp"
                      @change="getList"
                      name="datatable-checkbox_length"
                      aria-controls="datatable-checkbox"
                      class="form-control input-sm fontSize16"
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </label>
                </div>
                <table
                  class="table table-striped jambo_table bulk_action table-font-size"
                >
                  <thead>
                    <tr class="headings">
                      <th class="column-title">呼號/隊編</th>
                      <th class="column-title">司機姓名</th>
                      <th class="column-title">電話</th>
                      <th class="column-title">服務費</th>
                      <th class="column-title">出班費</th>
                      <th class="column-title">乘客險</th>
                      <th class="column-title">繳費</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(item, index) in list">
                      <tr class="headings">
                        <th class="call-name">{{ item.callNumber }}</th>
                        <th class="column-title">{{ item.name }}</th>
                        <th class="column-title">{{ item.phone }}</th>
                        <th class="column-title">
                          {{ item.isServiceFeePaid }}
                        </th>
                        <th class="column-title">{{ item.isShiftFeePaid }}</th>
                        <th class="column-title">{{ item.isInsurancePaid }}</th>
                        <th class="column-title">
                          <button
                            class="btn btn-danger"
                            @click="
                              payFee(item.driverId, item.name, item.callNumber)
                            "
                            v-show="!item.isPaid"
                          >
                            繳費
                          </button>
                        </th>
                      </tr>
                    </template>
                    <tr v-if="list.length == 0">
                      <td colspan="7" class="word_center">{{ message }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="pull-right">
                <ul class="pagination">
                  <li v-bind:class="{ disabled: page == 1 }">
                    <a
                      href="javascript:;"
                      @click="clickNewPage(1)"
                      v-bind:class="{ active: page == 1 }"
                    >
                      第一頁
                    </a>
                  </li>
                  <li>
                    <a
                      href="javascript:;"
                      @click="clickNewPage(pages_show_list[0] - 1)"
                      v-show="page - 2 > 1 && pages_show_list[0] - 1 != 1"
                    >
                      ...
                    </a>
                  </li>
                  <li
                    v-for="n in pages_show_list"
                    v-bind:class="{ active: n == page }"
                    @click="clickNewPage(n)"
                  >
                    <a href="javascript:;" ng-bind="n">{{ n }}</a>
                  </li>
                  <li>
                    <a
                      href="javascript:;"
                      @click="clickNewPage(pages_show_list[4] + 1)"
                      v-show="
                        page + 2 < totalPage &&
                        pages_show_list[4] + 1 < totalPage
                      "
                    >
                      ...
                    </a>
                  </li>
                  <li
                    v-show="totalPage > 1"
                    v-bind:class="{ disabled: page == totalPage }"
                  >
                    <a
                      href="javascript:;"
                      @click="clickNewPage(totalPage)"
                      v-bind:class="{ active: page == totalPage }"
                    >
                      最後一頁
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div
              class="tab-pane fade in"
              id="driver"
              role="tabpanel"
              aria-labelledby="driver-tab"
            >
              <div class="row">
                <div class="col-md-2">
                  <h4 class="black-word fontSize20">選擇呼號/隊編位置</h4>
                  <select
                    id="heard"
                    class="form-control fontSize16"
                    v-model="optCallNumber"
                    @change="onCallNumberOptionChange(optCallNumber)"
                    required=""
                  >
                    <option value="">呼號/隊編 - 姓名</option>
                    <option
                      v-for="driver in driver_options"
                      v-bind:value="driver.call_number"
                    >
                      {{ driver.call_number }} - {{ driver.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row" style="margin-top: 5px">
                <div class="col-md-5">
                  <input
                    type="number"
                    required="required"
                    class="inputstyle col-md-3 fontSize16"
                    placeholder="輸入呼號"
                    v-model="input_callNumber"
                  />
                  <button
                    type="button"
                    class="mybtnstyle btn-success"
                    @click="onSearchCallNumber"
                  >
                    搜尋
                  </button>
                </div>
              </div>
              <div class="row">
                <table
                  class="table table-striped jambo_table bulk_action table-font-size"
                >
                  <thead>
                    <tr class="headings">
                      <th class="column-title">呼號/隊編</th>
                      <th class="column-title">司機姓名</th>
                      <th class="column-title">電話</th>
                      <th class="column-title">服務費</th>
                      <th class="column-title">出班費</th>
                      <th class="column-title">乘客險</th>
                      <th class="column-title">繳費單時間</th>
                      <th class="column-title">經手者</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="item in singleDriverPayment">
                      <tr class="headings">
                        <th class="column-title">
                          {{ item.driverCallNumber }}
                        </th>
                        <th class="column-title">{{ item.driverName }}</th>
                        <th class="column-title">{{ item.driverAccount }}</th>
                        <th class="column-title">
                          {{ item.serviceFee }}/{{
                            item.isServiceFeePaid
                              ? '已繳完' + item.timeService
                              : '未繳完'
                          }}
                        </th>
                        <th class="column-title">
                          {{ item.shifeFee }}/{{
                            item.isShiftFeePaid
                              ? '已繳完' + item.timeShift
                              : '未繳完'
                          }}
                        </th>
                        <th class="column-title">
                          {{ item.insuranceForUser }}/{{
                            item.isInsurancePaid
                              ? '已繳完' + item.timeInsurance
                              : '未繳完'
                          }}
                        </th>
                        <th class="column-title">
                          {{ item.timeBegin }}~{{ item.timeUntil }}
                        </th>
                        <th class="column-title">
                          {{ item.managerName }}/{{ item.managerPosition }}
                        </th>
                      </tr>
                    </template>
                    <tr v-if="list.length == 0">
                      <td colspan="7" class="word_center">{{ message }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      id="paymentModal"
      class="modal fade bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3>繳費</h3>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="onCancelEditPaymentBtnClick"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <PayForm
            ref="payform"
            :name="driver.name"
            :callNumber="driver.callNumber"
            :paymentList="bills"
            :initial="show_payment_modal"
            @save-payment="savePayment"
          />
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="onCancelEditPaymentBtnClick"
            >
              關閉
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import API from '../../assets/js/libs/API'
import Cookies from 'js-cookie'
import moment from 'moment'
import axios from 'axios'
import PayForm from './PayForm.vue'

export default {
  name: 'PayDriverBill',
  components: {
    PayForm,
  },
  data() {
    return {
      bills: [],
      years: [],
      months: [],
      year: moment().year(),
      month: moment().month() + 1,
      list: [],
      singleDriverPayment: [],
      npp: 25,
      page: 1,
      kw: '',
      total: 0,
      totalPage: 0,
      message: '目前無資料',
      show_payment_modal: false,
      driver: {
        name: '',
        callNumber: '',
      },
      optCallNumber: null,
      input_callNumber: null,
      driver_options: [],
    }
  },
  methods: {
    onSearchCallNumber() {
      API.get(`singledriverpaymentlist/?callnumber=${this.input_callNumber}`)
        .then((res) => {
          if (res.result === 'err') {
            alert('無此司機')
            return
          }
          if (res.result === '無繳費單') {
            alert('無繳費單')
            return
          }
          this.singleDriverPayment = res.result.sort((a, b) => {
            return b.id - a.id
          })
        })
        .catch((err) => {
          console.log('searchCustomerInfo', err)
        })
    },
    onCallNumberOptionChange(callNumber) {
      API.get(`singledriverpaymentlist/?callnumber=${callNumber}`)
        .then((res) => {
          if (res.result === 'err') {
            alert('無此司機')
            return
          }
          if (res.result === '無繳費單') {
            alert('無繳費單')
            return
          }
          this.singleDriverPayment = res.result.sort((a, b) => {
            return b.id - a.id
          })
        })
        .catch((err) => {
          console.log('searchCustomerInfo', err)
        })
    },
    getHistoryPayment() {},
    getDriverList(teamcode) {
      API.get(`driver/list/?code=${teamcode}&task=general`)
        .then((res) => {
          this.driver_options = res.driverList.sort((a, b) => {
            return a.call_number - b.call_number
          })
        })
        .catch((err) => {
          console.log('searchCustomerInfo', err)
        })
    },
    getList() {
      this.list = []
      // console.log('--------->XXXXX',this.total)
      var totalCount = this.total
      this.message = '查詢中...'
      API.get(
        `gethasdriverpaidfeelist/?year=${this.year}&month=${this.month}&npp=${this.npp}&page=${this.page}`,
      )
        .then((res) => {
          this.total = res.result.total
          if (this.total == 0) this.message = '查無資料'
          this.list = res.result.list.filter((data) => {
            return data != null
          })
          // console.log('--------->',this.list)
          for (var i = 0; i < this.list.length; i++) {
            if (!this.list[i].isServiceFeePaid) {
              this.list[i].isServiceFeePaid = '未繳費'
            } else {
              this.list[i].isServiceFeePaid = '已繳費'
            }
            if (!this.list[i].isShiftFeePaid) {
              this.list[i].isShiftFeePaid = '未繳費'
            } else {
              this.list[i].isShiftFeePaid = '已繳費'
            }
            if (!this.list[i].isInsurancePaid) {
              this.list[i].isInsurancePaid = '未繳費'
            } else {
              this.list[i].isInsurancePaid = '已繳費'
            }
          }
          this.totalPage = Math.ceil(this.total / this.npp)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    payFee(driverId, name, callNumber) {
      $('#paymentModal').modal('show')
      this.driver.name = name
      this.driver.callNumber = callNumber
      this.updatedPayment(driverId)
    },
    clickNewPage(page) {
      this.page = page
      this.getList()
    },
    getYearOptions() {
      this.years.push(moment().year())
      if (moment().month() - 5 < 0) {
        this.years.push(moment().year() - 1)
      }
      this.getMonthOptions()
    },
    getMonthOptions() {
      this.months = []
      if (this.year == moment().year()) {
        for (var i = 0; i < 6; i++) {
          var month = moment().subtract(i, 'month').month() + 1
          if (month <= moment().month() + 1) {
            this.months.push(month)
          }
        }
      } else {
        for (var i = 0; i < 6; i++) {
          var month = moment().subtract(i, 'month').month() + 1
          if (month > moment().month() + 1) {
            this.months.push(month)
          }
        }
      }
    },
    onCancelEditPaymentBtnClick() {
      $('#paymentModal').modal('hide')
      this.clearAndInitial()
    },
    updatedPayment(driverId) {
      API.get(`driverpaymentlist/?id=${driverId}`)
        .then((detail) => {
          this.bills = detail.result
        })
        .catch((err) => {
          console.log(err)
        })
    },
    savePayment(data) {
      let id = data.id
      let payment = {
        has_service_fee_paid: data.is_service,
        has_shift_fee_paid: data.is_shift_fee,
        has_insurance_paid: data.is_insurance_fee,
      }

      if (data.is_shift_fee) {
        payment.shift_fee = data.shift_fee
      }

      if (confirm('確定繳費嗎')) {
        API.put(`updatepayment/?paymentid=${id}`, payment)
          .then((result) => {
            this.show_payment_modal = false
            alert(result.message)
            this.clearAndInitial()
          })
          .catch((err) => {
            alert('繳費失敗')
            console.log(err)
          })
      }
    },
    clearAndInitial() {
      this.bills = []
      this.getList()
      $('#paymentModal').modal('hide')
      this.$refs.payform.initialPaymentForm(true)
      // this.show_payment_modal = true
    },
  },
  computed: {
    pages_show_list: function () {
      var pages_show_list = []
      var totalPage = this.totalPage
      var newCurrent = this.page
      if (totalPage < 7) {
        for (var i = 2; i < totalPage; i++) {
          pages_show_list.push(i)
        }
      } else {
        if (newCurrent <= 4) {
          for (var i = 2; i < 7; i++) {
            pages_show_list.push(i)
          }
        } else if (newCurrent <= totalPage && newCurrent >= totalPage - 3) {
          for (var i = totalPage - 5; i < totalPage; i++) {
            pages_show_list.push(i)
          }
        } else {
          for (var i = -2; i < 3; i++) {
            pages_show_list.push(newCurrent + i)
          }
        }
      }
      return pages_show_list
    },
  },
  mounted() {
    const MainTeamCode = Cookies.get('GladTeamCode')
    this.getList()
    this.getYearOptions()
    this.getDriverList(MainTeamCode)
  },
}
</script>

<style scoped>
.mybtnstyle {
  margin-bottom: 10px;
}
.table-font-size {
  font-size: 14px;
}
.column-title {
  text-align: center;
}
.call-name {
  width: 15%;
}
.red_textcolor {
  color: red;
}
/* .item-btn{
  float: right;
} */
</style>



// WEBPACK FOOTER //
// src/pages/payment/PayDriverBill.vue